<template>
  <div class="jan2022 text-NotoSansLight bott">
    <header class="flex justify-end px-6">
      <router-link :to="{ name: 'index' }" class="block">
        <img class="object-contain h-16" src="~@/assets/images/2022Jan/logo.png" alt="livaABC">
      </router-link>
    </header>
    <div class="main w-full">
      <div class="fixed-btn fixed hidden lg:block z-50" :class="{ 'fixed-btn-show': isFixed }">
        <a @click="isFixed = !isFixed" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_01.png" class="object-contain"></a>
        <a @click="toTop(1)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_02.png" class="object-contain"></a>
        <a @click="toTop(2)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_03.png" class="object-contain"></a>
        <a @click="toTop(3)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_04.png" class="object-contain"></a>
        <a @click="toTop(4)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_05.png" class="object-contain"></a>
        <div><img src="~@/assets/images/2022Jan/bar/bar_06.png" class="object-contain"></div>
        <a @click="toBottom(1)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_07.png" class="object-contain"></a>
        <a @click="toBottom(2)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_08.png" class="object-contain"></a>
        <a @click="toBottom(3)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_09.png" class="object-contain"></a>
        <a @click="toBottom(4)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_10.png" class="object-contain"></a>
        <a @click="toBottom(5)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_11.png" class="object-contain"></a>
        <a @click="toBottom(6)" class="cursor-pointer block"><img src="~@/assets/images/2022Jan/bar/bar_12.png" class="object-contain"></a>
      </div>

      <section class="section1">
        <div class="container p-2 md:p-4">
          <div data-aos="fade-up" data-aos-once="true" class="flex justify-center mb-4">
            <div><img src="~@/assets/images/2022Jan/top-tiger-11.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div><img src="~@/assets/images/2022Jan/top-word-12.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div><img src="~@/assets/images/2022Jan/top-girl-11.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          </div>
          <div class="py-3">
            <img src="~@/assets/images/2022Jan/time-13.png" class="object-contain mx-auto">
          </div>
          <div class="py-3">
            <img src="~@/assets/images/2022Jan/bowknot.png" class="object-contain mx-auto w-48 md:w-auto">
          </div>
          <div class="flex justify-center mb-4 flex-wrap">
            <div @click="toTop(1)" class="w-1/2 md:w-1/4 cursor-pointer"><img src="~@/assets/images/2022Jan/top BT (1).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div @click="toTop(2)" class="w-1/2 md:w-1/4 cursor-pointer"><img src="~@/assets/images/2022Jan/top BT (2).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div @click="toTop(3)" class="w-1/2 md:w-1/4 cursor-pointer"><img src="~@/assets/images/2022Jan/top BT (3).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div @click="toTop(4)" class="w-1/2 md:w-1/4 cursor-pointer"><img src="~@/assets/images/2022Jan/top BT (4).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          </div>
        </div>
      </section>

      <section class="section2">
        <div class="container p-2 md:p-4">
          <div class="cash flex justify-center mb-4" id="top1">
            <div>
              <img src="~@/assets/images/2022Jan/text.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/text_m.png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
          <div class="flex justify-center mb-4" id="top2">
            <div>
              <img src="~@/assets/images/2022Jan/bn(1).png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/bn_m(5).png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
          <div class="flex flex-col md:flex-row justify-center items-center mb-4">
            <div class="w-full md:w-2/3 p-2">
              <img src="~@/assets/images/2022Jan/content.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/content_m.png" class="object-contain mx-auto md:hidden">
            </div>
            <router-link :to="{ name: 'sale', params: { category: 'recent' }, query: { tag: 121 } }" class="cursor-pointer w-full md:w-1/3 p-2"><img src="~@/assets/images/2022Jan/BT-more2.png" class="object-contain block mx-auto"></router-link>
          </div>
          <div class="p-2 md:px-16">
            <div class="items flex mb-4 flex-wrap bg-white p-4">
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7555 } }" class="w-1/2 md:w-1/4"><img src="~@/assets/images/2022Jan/ABC.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7556 } }" class="w-1/2 md:w-1/4"><img src="~@/assets/images/2022Jan/Live.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7557 } }" class="w-1/2 md:w-1/4"><img src="~@/assets/images/2022Jan/ALL.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7559 } }" class="w-1/2 md:w-1/4"><img src="~@/assets/images/2022Jan/JP.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7558 } }" class="w-1/2 md:w-1/4"><img src="~@/assets/images/2022Jan/CNN.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
              <div class="w-full md:w-3/4"><img src="~@/assets/images/2022Jan/pen.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            </div>
          </div>
        </div>
      </section>

      <section class="section3" id="top3">
        <div class="container p-2 md:p-4">
          <div class="flex justify-center mb-4">
            <div>
              <img src="~@/assets/images/2022Jan/bn(2).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/bn_m(4).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </div>
          </div>
          <div class="more mb-4 px-4">
            <router-link :to="{ name: 'sale', params: { category: 'recent' }, query: { tag: 125 } }" class="cursor-pointer p-2 block"><img src="~@/assets/images/2022Jan/BT-more1.png" class="object-contain block mx-auto"></router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData1">
            <router-link  :to="{ name: 'detail', params: { category: item.type.toLowerCase(), id: item.id } }" class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData1" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </section>

      <section class="section4" id="top4">
        <div class="container p-2 md:p-4">
          <div class="flex justify-center mb-4">
            <div>
              <img src="~@/assets/images/2022Jan/bn(3).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/bn_m(3).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </div>
          </div>
          <div class="more mb-4 mx-2 md:mx-4">
            <router-link :to="{ name: 'sale', params: { category: 'recent' }, query: { tag: 126 } }" class="cursor-pointer p-2 block"><img src="~@/assets/images/2022Jan/BT-more1.png" class="object-contain block mx-auto"></router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData2">
            <router-link :to="{ name: 'detail', params: { category: item.type.toLowerCase(), id: item.id } }" class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData2" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">【電腦互動學習軟體】</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="py-3 pb-6">
            <img src="~@/assets/images/2022Jan/bowknot.png" class="object-contain mx-auto w-48 md:w-auto">
          </div>
        </div>
      </section>

      <section class="section5">
        <div class="container p-2 md:p-4">
          <div class="tags flex justify-center mb-4 items-center bg-white p-4 md:p-6 shadow-lg">
            <div class="w-full md:w-10/12 flex justify-center flex-wrap">
              <div @click="toBottom(1)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(1).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
              <div @click="toBottom(2)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(2).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
              <div @click="toBottom(3)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(3).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
              <div @click="toBottom(4)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(4).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
              <div @click="toBottom(5)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(5).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
              <div @click="toBottom(6)" class="w-1/2 md:w-1/3 p-2 cursor-pointer"><img src="~@/assets/images/2022Jan/BT-(6).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            </div>
            <div class="w-2/12 hidden md:block"><img src="~@/assets/images/2022Jan/bn(4).png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          </div>
          <div class="flex justify-end mb-4" id="bottom1">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 102 } }">
              <img src="~@/assets/images/2022Jan/book(6).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(7).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData3">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData3" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end mb-4" id="bottom2">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 113 } }">
              <img src="~@/assets/images/2022Jan/book(11).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(5).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData4">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData4" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end mb-4" id="bottom3">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 101 } }">
              <img src="~@/assets/images/2022Jan/book(7).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(9).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData5">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData5" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end mb-4" id="bottom4">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 103 } }">
              <img src="~@/assets/images/2022Jan/book(8).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(4).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData6">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData6" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end mb-4" id="bottom5">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 110 } }">
              <img src="~@/assets/images/2022Jan/book(10).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(6).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData7">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData7" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end mb-4" id="bottom6">
            <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 111 } }">
              <img src="~@/assets/images/2022Jan/book(9).png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block">
              <img src="~@/assets/images/2022Jan/book_m(8).png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden">
            </router-link>
          </div>
          <div class="items flex mb-4 flex-wrap p-2 xl:px-8" v-if="sectionData8">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }"  class="item w-1/2 md:w-1/4 p-1" v-for="(item, index) in sectionData8" :key="index">
              <div class="item-content bg-white p-3 h-full">
                <div class="promote-text p-1 py-2">
                  <p class="text-white text-center text-xs">{{ item.introduction }}</p>
                </div>
                <div class="outer">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">
                    <img :src="item.cover" class="w-full h-full object-contain block">
                  </div>
                </div>
                <div class="item-name px-2 py-4 text-gray flex justify-center items-center">
                  <p class="text-center text-sm font-bold tracking-wider break-words">{{ item.name }}</p>
                </div>

                <div class="lg:flex justify-center items-center text-gray tracking-wider font-semibold border-t-2 pt-4 pb-3">
                  <span class="text-xs m-0">原價{{ item.fixed_price }}元</span>
                  <span class="text-xs mx-1">►</span>
                  <p class="text-sm m-0 flex items-center">優惠價<span class="price-fixed text-lg">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="py-3 pb-6">
            <img src="~@/assets/images/2022Jan/bowknot.png" class="object-contain mx-auto w-48 md:w-auto">
          </div>
        </div>
      </section>

      <section class="section6 pb-6 px-2" id="Intro">
        <div class="max-w-4xl mx-auto flex items-start">
          <img src="~@/assets/images/2022Jan/attention.png" class="object-contain w-20">

          <div class=" mx-auto px-6">
            <ul class="list-decimal list-outside font-semibold leading-loose">
              <li>活動期間2022.1.1~2022.2.28於LiveABC官方網站及紙本雜誌訂購單購買商品，訂單成立後即可參加「下單抽現金8,888元」活動，1筆訂單能參與抽獎乙次。</li>
              <li>下單抽現金活動為月月抽，共會抽出兩名得主 (於1/1-1/31期間消費抽出乙名、於2/1-2/28期間消費抽出乙名)；抽獎公佈日期：2022/2/20、2022/3/20公佈於LiveABC官方網站及官方臉書粉絲團。</li>
              <li>於活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格。</li>
              <li>詳細活動時間與內容以LiveABC官網發布為主 (https://store.liveabc.com/)。</li>
              <li>中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
              <li>本活動之抽獎贈品不得轉換、轉讓或折換現金。</li>
              <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利，並將最新變更後內容公布於官網活動頁面，不再個別提醒/通知客戶本 活動內容之變更。</li>
            </ul>
          </div>
        </div>
      </section>

      <footer class="section6 pt-24 pb-12 flex justify-center">
        <router-link :to="{ name: 'index' }" class="block mx-auto">
          <img class="object-contain h-16" src="~@/assets/images/2022Jan/logo.png" alt="livaABC">
        </router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
export default {
  name: 'Jan2022',
  metaInfo () {
    return {
      title: '新春開運大寶帖 有讀有保庇-Happy虎 Year',
      titleTemplate: null
    }
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: true,
      sectionData1: null,
      sectionData2: null,
      sectionData3: null,
      sectionData4: null,
      sectionData5: null,
      sectionData6: null,
      sectionData7: null,
      sectionData8: null
    }
  },
  async mounted () {
    await this.getEvent1()
    await this.getEvent2()
    await this.getEvent3()
    await this.getEvent4()
    await this.getEvent5()
    await this.getEvent6()
    await this.getEvent7()
    await this.getEvent8()
  },
  destroyed () {
  },
  methods: {
    getEvent1 () {
      let self = this
      let arr = [
        { id: 7208, introduction: '新世代用語你不能不知' },
        { id: 7382, introduction: '打造最強日語基本功' },
        { id: 7414, introduction: '打造新聞英語超強實力' },
        { id: 6569, introduction: '老外都在用的道地口語' },
        { id: 7388, introduction: '職場英語迅速上手' },
        { id: 7235, introduction: '跟著粉紅豬小妹學英語' },
        { id: 6771, introduction: '一片單字海中不迷茫' },
        { id: 6609, introduction: '多益考前衝刺必備' },
        { id: 7063, introduction: '扎根英語閱讀基礎' },
        { id: 5936, introduction: '小學生英文檢測必備' },
        { id: 7065, introduction: '追星追劇韓文入門必看' },
        { id: 6564, introduction: '全彩圖像接軌國際' }
      ]
      axios.get('/promote_events/125')
        .then((response) => {
          response.data.items.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData1 = arr
        })
    },
    getEvent2 () {
      let self = this
      let arr = [
        { id: 7509, introduction: '新世代用語你不能不知' },
        { id: 7510, introduction: '打造最強日語基本功' },
        { id: 7511, introduction: '打造新聞英語超強實力' },
        { id: 7542, introduction: '老外都在用的道地口語' },
        { id: 7502, introduction: '職場英語迅速上手' },
        { id: 7503, introduction: '跟著粉紅豬小妹學英語' },
        { id: 7454, introduction: '一片單字海中不迷茫' },
        { id: 7292, introduction: '多益考前衝刺必備' }
      ]
      axios.get('/promote_events/126')
        .then((response) => {
          response.data.items.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData2 = arr
        })
    },
    getEvent3 () {
      let self = this
      let arr = [
        { id: 7456, introduction: '沈志安老師獨家揭露' },
        { id: 7399, introduction: '用心智圖聰明背單字' },
        { id: 4229, introduction: '最新模考試題+拿分解析' },
        { id: 5910, introduction: '掌握多益題型應考技巧' },
        { id: 6779, introduction: '要你考一次就拿高分' },
        { id: 6869, introduction: '雅思考高分再也不難' },
        { id: 905, introduction: '六大教學記憶法超輕鬆' },
        { id: 7104, introduction: '增加實戰經驗練習寶典' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData3 = arr
        })
    },
    getEvent4 () {
      let self = this
      let arr = [
        { id: 7323, introduction: '主編獨家編排學習法' },
        { id: 7218, introduction: '英文五大題型完整搜羅' },
        { id: 6757, introduction: '複習統測必考重點' },
        { id: 6610, introduction: '你只要看這一本就夠' },
        { id: 6393, introduction: '選擇適合你的學習計劃' },
        { id: 6355, introduction: '選擇適合你的學習計劃' },
        { id: 6401, introduction: '用英語跨領域學習' },
        { id: 6570, introduction: '用英語跨領域學習' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData4 = arr
        })
    },
    getEvent5 () {
      let self = this
      let arr = [
        { id: 7467, introduction: '走遍達人推薦世界景點' },
        { id: 7219, introduction: '5大場景學好英語會話' },
        { id: 7149, introduction: '快來#hashtag 學英語' },
        { id: 7003, introduction: '臨場實戰說對英語' },
        { id: 6934, introduction: '全方位搞定英語發音' },
        { id: 6872, introduction: '在家也能學好英語會話' },
        { id: 6618, introduction: '一書在手暢遊無阻' },
        { id: 6385, introduction: '大明星來教你說英語' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData5 = arr
        })
    },
    getEvent6 () {
      let self = this
      let arr = [
        { id: 7236, introduction: '職場商用文書必備技能' },
        { id: 6936, introduction: '打造成功的英語簡報' },
        { id: 6835, introduction: '培養商場英語溝通力' },
        { id: 6361, introduction: '擺脫晶晶體流利說英語' },
        { id: 6146, introduction: '新聞主播常用關鍵字彙' },
        { id: 7138, introduction: '最佳英語聽力教材' },
        { id: 6871, introduction: '成功企業的致勝之道' },
        { id: 6217, introduction: '累積新聞英語單字量' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData6 = arr
        })
    },
    getEvent7 () {
      let self = this
      let arr = [
        { id: 7494, introduction: '唱歌學英語生動有趣' },
        { id: 6935, introduction: '背單字輕鬆又有趣' },
        { id: 7549, introduction: '走遍世界各地學英語' },
        { id: 5922, introduction: '養成良好品格故事集' },
        { id: 1704, introduction: '深具寓意的英語小故事' },
        { id: 4660, introduction: '從各個角度來看世界' },
        { id: 6099, introduction: '卡通學英語可愛又有趣' },
        { id: 7458, introduction: '符合108課綱英語教材' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData7 = arr
        })
    },
    getEvent8 () {
      let self = this
      let arr = [
        { id: 7355, introduction: '穿越時空的回溯之旅' },
        { id: 7134, introduction: '新奇的陸海空交通工具' },
        { id: 5967, introduction: '幫你一次掌握最新科技' },
        { id: 5977, introduction: '探索深度的太空之旅' },
        { id: 6615, introduction: '海陸空軍事大集結' },
        { id: 6189, introduction: '息息相關的萬物生態' },
        { id: 6007, introduction: '無所不在的科學原理' }
      ]
      let pathArr = []
      for (let i = 0; i < arr.length; i++) {
        pathArr.push(arr[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            arr.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })

          self.sectionData8 = arr
        })
    },
    toTop (n) {
      jump(`#top${n}`, {
        duration: 500,
        offset: 0
      })
    },
    toBottom (n) {
      jump(`#bottom${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.price-fixed {
  color: #ec8251;
}
.text-gray {
  color: #535356;
}
.btn {
  width: 220px;
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.jan2022 {
  background-image: url('~@/assets/images/2022Jan/BG.png');
  background-size: contain;
  background-size: 300px 300px;
  .main {
    // background: #F3F3E9;
    .fixed-btn {
      top: 50%;
      transform: translateY(-50%);
      width: 240px;
      left: -12em;
      transition: 0.3s;
    }
    .fixed-btn-show {
      left: 0;
    }
    .section1 {
      padding-Bottom: 15%;
      @media (max-width: 767px) {
        padding-Bottom: 70%;
      }
    }
    .section2 {
      background-color: #f4d3ba;
      .cash {
        margin-top: -20%;
        @media (max-width: 767px) {
          margin-top: -70%;
        }
      }
      .items {
        border-radius: 30px;
      }
    }
    .section3 {
      background-color: #c4ebe0;
      .more {
        width: 220px;
      }
      .items {
        .item {
          .item-content {
            border-radius: 10px;
          }
          .item-name {
            height: 70px;
            @media (max-width: 1024px) {
              height: 90px;
            }
          }
        }
        .promote-text {
          border-radius: 20px;
          background-color: #878789;
        }
      }
    }
    .section4 {
      background-color: #c8c7b2;
      padding-Bottom: 10%;
        @media (max-width: 767px) {
          padding-Bottom: 20%;
        }
      .more {
        width: 220px;
      }
      .items {
        .item {
          .item-content {
            border-radius: 10px;
          }
          .item-name {
            height: 70px;
            @media (max-width: 1024px) {
              height: 90px;
            }
          }
        }
        .promote-text {
          border-radius: 20px;
          background-color: #878789;
        }
      }
    }
    .section5 {
      background-color: #f7f6e7;
      // padding-Bottom: 15em;
      .more {
        width: 220px;
      }
      .tags {
        margin-top: -10%;
        @media (max-width: 767px) {
          margin-top: -25%;
        }
      }
      .items {
        .item {
          .item-content {
            border-radius: 10px;
          }
          .item-name {
            height: 70px;
            @media (max-width:1024px) {
              height: 90px;
            }
          }
        }
        .promote-text {
          border-radius: 20px;
          background-color: #878789;
        }
      }
    }
    .section6 {
      background-color: #f7f6e7;
    }
  }
}
</style>
